// src/App.jsx
import React from 'react';
import Home from './components/Home';

function App() {
  return (
    <div className="min-h-screen bg-black bg-cover bg-center bg-no-repeat text-white"
      style={{
        backgroundImage: 'url(/assets/background.jpg)',
      }}
    >
      <div className="min-h-screen bg-black/50">
        <Home />
      </div>
    </div>
  );
}

export default App;